import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IActivityLog,
  IGetActivityLogParams,
  IGetActivityLogsParams,
} from '@network/models/activity-log.model'

export class ActivityLogsApi {
  constructor(private axios: AxiosService) {}

  getActivityLogs = async <T>(params?: IGetActivityLogsParams) => {
    const response = await this.axios.get<IPayload<IActivityLog<T>[]>>(
      Endpoints.getActivityLogs,
      params,
    )
    return response
  }

  getActivityLog = async <T>(id: number, params?: IGetActivityLogParams) => {
    const response = await this.axios.get<IPayload<IActivityLog<T>>>(
      Endpoints.getActivityLog(id),
      params,
    )
    return response
  }
}
